module.exports = __webpack_public_path__ + "static/img/reyzarConceeptPic4.deab802.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/reyzarConceeptPic4.png
// module id = xyVX
// module chunks = 0